import { Table } from '@tanstack/react-table';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Select';
import { PaginationConfigProps } from '../types';

interface RowsPerPageSelectorProps<TData> {
  table: Table<TData>;
  config: PaginationConfigProps;
  onPageSizeChange: (pageSize: number) => void;
  currentPageSize: number;
}

export function RowsPerPageSelector<TData>({
  table,
  config,
  onPageSizeChange,
  currentPageSize,
}: RowsPerPageSelectorProps<TData>) {
  const defaultOptions = [5, 10, 20, 50, 100];
  const options = config.rowsPerPageOptions || defaultOptions;

  // Ensure the current page size is valid, fallback to config.pageSize
  const validPageSize = options.includes(currentPageSize)
    ? currentPageSize
    : config.pageSize;

  const handleValueChange = (value: string) => {
    const newPageSize = parseInt(value, 10);
    onPageSizeChange(newPageSize);
  };

  return (
    <div className="flex items-center gap-md">
      <span className="txt-small-regular text-text-tertiary shrink-0">
        No of rows
      </span>
      <Select
        value={validPageSize.toString()}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className="h-8 text-center bg-bg-primary hover:bg-bg-primary-hover border-0 outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none active:outline-none">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={option.toString()}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
